import asyncSweetScroll from '@/helpers/sweet_scroll';
import { CITY_LANDING_PAGE_IDS } from '@/pages/city_landing/page_ids';

pageLoad(...CITY_LANDING_PAGE_IDS, () => {
  $('article.v4.free_boxes_counter .to-map').on('click', () => {
    asyncSweetScroll('article.v4.storages_map');
  });
});
